var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBoldButton(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M432.351,289.584c-14.305-20.514-36.456-34.17-66.463-40.967c23.916-9.608,41.613-23.907,53.101-42.9 c11.491-18.999,17.229-40.673,17.229-65.057c0-46.651-17.819-81.761-53.448-105.318C347.135,11.781,297.548,0,234.023,0H58.197 v512h201.142c62.599,0,110.653-12.772,144.182-38.331c33.518-25.547,50.281-63.293,50.281-113.227 C453.803,333.721,446.645,310.099,432.351,289.584z M177.408,91.429h56.618c28.133,0,48.994,4.985,62.599,14.946 c13.591,9.966,20.393,25.843,20.393,47.648c0,19.225-6.684,33.817-20.046,43.778c-13.365,9.966-33.529,15.183-60.488,15.651 h-59.076V91.429z M316.31,405.623c-12.659,9.966-31.649,14.951-56.971,14.951h-81.931V292.223h88.62 c24.379,0,42.02,5.685,52.918,17.051c10.904,11.372,16.357,28.192,16.357,50.465C335.303,380.369,328.966,395.662,316.31,405.623z "
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoldButton);
export default __webpack_public_path__ + "static/media/bold-button.790eb48532d5abcc0a6017b08ba2d790.svg";
export { ForwardRef as ReactComponent };